@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/typography/typography' as *;

.container {
  display: flex;
  align-items: center;
  gap: 12px;
  background: var(--background-soft);
  @include border-radius-r1;
  margin-left: 8px;
}

.item {
  display: flex;
  padding: 2px 4px;
  align-items: center;
  gap: 8px;
}


.label {
  @include typography-v2-body-sm;
}

.value {
  font-family: var(--font-roboto-mono);
  @include typography-v2-body-sm;
}

.positiveLine {
  width: 12px;
  height: 2px;
  @include border-radius-r05;
  background-color: var(--viz-bullish);
}

.negativeIndicator {
  display: flex;
  gap: 1px;
}

.negativeLine {
  width: 4px;
  border: none;
  @include border-radius-r05;
  border-top: 2px solid var(--viz-bearish);
}
